import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Logo from '../ProjectNexus_LogoJust_Trans.svg';

const Hero = () => {
    const [lang, setLang] = useState('jp');

    useEffect(() => {
        const interval = setInterval(() => {
            setLang(prev => prev === 'en' ? 'jp' : 'en');
        }, 10000);
        return () => clearInterval(interval);
    }, []);

    const content = {
        jp: {
            line1: "Project NEXUSは、「Cloud Strategy & Design」の専門家集団です。",
            line2: "「IT職人のギルド」として経営・業務・技術・人を繋ぎ、",
            line3: "構想を具現化するための設計とアドバイザリーを提供します。"
        },
        en: {
            line1: "“Project NEXUS” is a guild of experts in Cloud Strategy & Design.",
            line2: "We bridge Management, Operations, and Engineering,",
            line3: "providing high-quality advisory and design support to shape your vision into reality."
        }
    };

    return (
        <section className="relative w-full max-w-none min-h-screen flex flex-col items-center justify-center bg-white dark:bg-gray-900 transition-colors duration-300 py-24">
            <div className="flex flex-col items-center px-4 text-center w-full">
                <div className="logo-container mb-10 relative group">
                    <img
                        src={Logo}
                        alt="Project NEXUS Logo"
                        className="h-32 md:h-48 w-auto logo drop-shadow-xl brightness-0 dark:invert"
                    />
                    <div className="absolute -bottom-2 right-0 text-gray-900 dark:text-white text-xs md:text-sm font-light tracking-wider">
                        by eriver.jp
                    </div>
                </div>

                <div className="text-container w-full max-w-3xl h-48 md:h-40 relative">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={lang}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.8 }}
                            className="absolute inset-0 flex flex-col items-center w-full"
                        >
                            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-6 leading-tight w-full">
                                {content[lang].line1}
                            </h1>
                            <p className="text-lg md:text-xl text-gray-600 dark:text-gray-200 w-full">
                                {content[lang].line2}
                            </p>
                            <p className="text-lg md:text-xl text-gray-600 dark:text-gray-200 mt-2 w-full">
                                {content[lang].line3}
                            </p>
                        </motion.div>
                    </AnimatePresence>
                </div>

                <div className="mt-12">
                    <a
                        href="#challenges"
                        className="inline-block px-8 py-3 bg-gray-900 dark:bg-white hover:bg-gray-700 dark:hover:bg-gray-200 text-white dark:text-gray-900 font-semibold rounded-full transition-all shadow-lg"
                    >
                        相談できることを見る
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Hero;
